import { find } from "utils/dom"
import Swiper_Criancas from "../Swiper/SwiperCrianca"
import Swiper from "swiper"
import { Grid, Navigation, Pagination } from "swiper/modules"
import { findAll } from "../utils/dom"

const GRID_ROWS = 5
const DESKTOP_BREAKPOINT = 767

const padParceirosGridSlides = (wrapper) => {
    wrapper.querySelectorAll(".swiper-slide-blank").forEach((slide) => slide.remove())

    const slides = wrapper.querySelectorAll(".swiper-slide:not(.swiper-slide-blank)")
    const remainder = slides.length % GRID_ROWS
    if (remainder === 0) return

    for (let i = 0; i < GRID_ROWS - remainder; i++) {
        const blank = document.createElement("div")
        blank.className = "swiper-slide swiper-slide-blank swiper-slide-invisible-blank"
        blank.setAttribute("aria-hidden", "true")
        wrapper.appendChild(blank)
    }
}

/** fill:column — altura = maior coluna (grupos de N linhas); inclui margens do grid. */
const syncGridHeightParceiros = (swiper) => {
    const rows = swiper.params.grid?.rows ?? 1
    const realSlides = swiper.slides.filter((el) => !el.classList.contains("swiper-slide-blank"))

    if (rows <= 1 || !realSlides.length) {
        swiper.el.style.height = ""
        return
    }

    swiper.el.style.height = "auto"
    realSlides.forEach((slide) => {
        slide.style.height = "auto"
    })

    let maxHeight = 0

    for (let start = 0; start < realSlides.length; start += rows) {
        const end = Math.min(start + rows, realSlides.length) - 1
        const first = realSlides[start]
        const last = realSlides[end]
        const blockHeight = last.offsetTop + last.offsetHeight - first.offsetTop
        maxHeight = Math.max(maxHeight, blockHeight)
    }

    if (maxHeight > 0) {
        swiper.el.style.height = `${Math.ceil(maxHeight) + 1}px`
    }
}

const updateParceirosSwiper = (swiper) => {
    requestAnimationFrame(() => {
        syncGridHeightParceiros(swiper)
        swiper.update()
    })
}

export default function () {
    const Home = find("[js-page='apoiadores']")
    if (!Home) return

    Swiper_Criancas()

    const parceirosWrapper = find(".Swiper-Parceiros .swiper-wrapper")
    if (parceirosWrapper) {
        padParceirosGridSlides(parceirosWrapper)
    }

    const SwiperParceiros = new Swiper(".Swiper-Parceiros", {
        modules: [Grid, Navigation, Pagination],
        slidesPerView: 1,
        slidesPerGroup: 1,
        grid: {
            rows: GRID_ROWS,
            fill: "column",
        },
        breakpoints: {
            [DESKTOP_BREAKPOINT]: {
                slidesPerView: 2,
                slidesPerGroup: 1,
                grid: {
                    rows: GRID_ROWS,
                    fill: "column",
                },
            },
        },
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        pagination: {
            el: "[js-controle-swiper='Swiper-Parceiros'] .swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: "[js-controle-swiper='Swiper-Parceiros'] .swiper-button-next",
            prevEl: "[js-controle-swiper='Swiper-Parceiros'] .swiper-button-prev",
        },
        on: {
            init(swiper) {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => updateParceirosSwiper(swiper))
                })
            },
            resize(swiper) {
                updateParceirosSwiper(swiper)
            },
            breakpoint(swiper) {
                requestAnimationFrame(() => updateParceirosSwiper(swiper))
            },
        },
    })

    const realSlides = SwiperParceiros.slides.filter((el) => !el.classList.contains("swiper-slide-blank"))
    const resizeObserver = new ResizeObserver(() => updateParceirosSwiper(SwiperParceiros))
    realSlides.forEach((slide) => resizeObserver.observe(slide))

    findAll(".Swiper-Parceiros img").forEach((img) => {
        if (img.complete) return
        img.addEventListener("load", () => updateParceirosSwiper(SwiperParceiros), { once: true })
    })

    const SwiperNavParceirosEmbaixadores = new Swiper(".Swiper-Nav-Parceiros-Embaixadores", {
        slidesPerView: "auto",
        spaceBetween: 8,
    })

    const SwiperCardApoiadores = new Swiper(".Swiper-Card-Apoiadores", {
        slidesPerView: 1.1,
        spaceBetween: 8,
        autoplay: {
            delay: 2500,
        },
        speed: 1000,
    })

    const Buttons = findAll("[js-button]")
    if (Buttons) {
        Buttons.forEach((button) => {
            button.addEventListener("click", (e) => {
                const Botao_Ativo = find("[js-button].active")
                Botao_Ativo.classList.remove("active")

                e.target.classList.add("active")

                const Pagina_Para_Ativar = e.target.getAttribute("js-button")
                const Pagina_Ativa = find("[js-tipo-page].is-page-active")
                Pagina_Ativa.classList.remove("is-page-active")

                const Nova_Pagina_Ativa = find(`[js-tipo-page=${Pagina_Para_Ativar}]`)
                Nova_Pagina_Ativa.classList.add("is-page-active")

                if (Pagina_Para_Ativar === "parceiros") {
                    requestAnimationFrame(() => updateParceirosSwiper(SwiperParceiros))
                }
            })
        })
    }

    const busca = window.location.search
    const ObjetoBusca = busca.split("?")
    ObjetoBusca.forEach((item) => {
        if (item.includes("tipo-pagina")) {
            const Result = item.split("=")

            const Botao_Ativo = find("[js-button].active")
            Botao_Ativo.classList.remove("active")

            const Botao_Ativo_Novo = find(`[js-button=${Result[1]}]`)
            Botao_Ativo_Novo.classList.add("active")

            const Pagina_Ativa = find("[js-tipo-page].is-page-active")
            Pagina_Ativa.classList.remove("is-page-active")

            const Nova_Pagina_Ativa = find(`[js-tipo-page=${Result[1]}]`)
            Nova_Pagina_Ativa.classList.add("is-page-active")
        }
    })
}
